// src/features/production/shortageHold/components/BomOperationAllocationPicker.tsx

import { useMemo } from "react";
import { useBomOperationAllocationsList, useWorkOrderRetrieve } from "../api";

interface Props {
  workOrderId: string;
  value: string;
  onChange: (allocationId: string) => void;
}

export function BomOperationAllocationPicker({ workOrderId, value, onChange }: Props) {
  const { data: workOrder } = useWorkOrderRetrieve(workOrderId || undefined);
  const { data: allocations = [], isLoading } = useBomOperationAllocationsList();

  const filtered = useMemo(() => {
    if (!workOrder?.operation) return [];
    return allocations.filter((a) => a.routing_operation === workOrder.operation);
  }, [allocations, workOrder]);

  const disabled = !workOrderId || isLoading;

  return (
    <select
      aria-label="Missing Allocation"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{
        width: "100%",
        padding: "10px 12px",
        borderRadius: "10px",
        border: "1px solid var(--color-border, #E4DCC8)",
        background: "#FFFFFF",
        color: "#2B2B2B",
        fontSize: "0.9rem",
        outline: "none",
      }}
    >
      <option value="">
        {!workOrderId
          ? "ابتدا Work Order را انتخاب کنید"
          : isLoading
            ? "در حال بارگذاری..."
            : filtered.length === 0
              ? "هیچ تخصیصی برای این عملیات یافت نشد"
              : "انتخاب قطعه‌ی کم‌بود (BOM Allocation)"}
      </option>
      {filtered.map((a) => (
        <option key={a.id} value={a.id}>
          {a.bom_item_display ?? `تخصیص قطعه (${a.id.slice(0, 8)})`}
        </option>
      ))}
    </select>
  );
}
